"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fullscreen = void 0;

var react_1 = __importDefault(require("react"));

var icons_1 = require("../../../icons");

var MediaPlaybackContext_1 = require("../MediaPlaybackContext");

var styled_1 = require("../styled");

function Fullscreen(_ref) {
  var compact = _ref.compact;

  var _ref2 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      duration = _ref2.duration,
      setFullscreen = _ref2.setFullscreen,
      fullscreen = _ref2.fullscreen;

  if (duration) {
    var IconComponent = fullscreen ? icons_1.Reduce : icons_1.Enlarge;
    return react_1.default.createElement(styled_1.ControlContainer, {
      compact: compact !== undefined,
      onClick: function onClick() {
        return setFullscreen(function (f) {
          return !f;
        });
      }
    }, react_1.default.createElement(IconComponent, null));
  } else {
    return null;
  }
}

exports.Fullscreen = Fullscreen;